import { IDB_rowRead, IDB_rowsReadAll, IDB_rowWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { Imag_FileLookup } from '../Imag/Imag.LegacyFile'

export function IDB_fileLookupRead(fileId: number | string) {
    return IDB_rowRead<Imag_FileLookup>(IDB_globalDb, 'files', fileId)
}

export function IDB_fileLookupsReadAll() {
    return IDB_rowsReadAll<Imag_FileLookup>(IDB_globalDb, 'files')
}

export function IDB_fileLookupWrite(fileLookup: Imag_FileLookup) {
    return IDB_rowWrite(IDB_globalDb, 'files', fileLookup)
}
